import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { profileApi, statsApi, userApi } from '@/common/services/api'
import { OFFSET_COUNT_LOAD_PROFILE_HISTORY } from '@/common/constants/count'
import { DEFAULT_HISTORY_PARAMS } from '@/common/constants/profile'

export const initProfileRefferal = createAsyncThunk(
  'profile/initProfileRefferal',
  async (_, { rejectWithValue }) => {
    try {
      const response = await statsApi.getRefferalsStats()

      return {
        refferals: response?.reflink_stats,
      }
    } catch (e) {
      return rejectWithValue(e)
    }
  }
)

export const fetchProfileHistory = createAsyncThunk(
  'profile/fetchProfileHistory',
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState()

      const response = await profileApi.getProfileHistory({
        params: {
          ...state.profile.historyParams,
        },
      })

      return {
        history: response.history,
        pagination: response.pagination,
      }
    } catch (e) {
      return rejectWithValue(e)
    }
  }
)

export const createRefferalLink = createAsyncThunk(
  'profile/createRefferalLink',
  async (_, { rejectWithValue }) => {
    try {
      const response = await userApi.createRefferalLink()

      return {
        link: response.link,
      }
    } catch (e) {
      return rejectWithValue(e)
    }
  }
)

const initialState = {
  history: [],
  pagination: {},
  categories: [],
  sorting: [],
  historyParams: {
    offset: 0,
    limit: OFFSET_COUNT_LOAD_PROFILE_HISTORY,
  },
  isLoadingHistory: true,
  isLoadingRefferals: true,
  refferalLinks: [],
}

export const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    updateHistoryParams(state, { payload }) {
      state.historyParams[payload.field] = payload.value
    },
    resetHistory(state) {
      state.history = []
    },
    clear(state) {
      state.pagination = {}
      state.historyParams = Object.assign(
        state.historyParams,
        DEFAULT_HISTORY_PARAMS
      )
    },
    updateCorrectOffsetAndLimitHistoryParams(state) {
      const limit =
        state.pagination?.current?.offset + state.pagination?.current?.limit

      state.historyParams.offset = 0
      state.historyParams.limit = limit || OFFSET_COUNT_LOAD_PROFILE_HISTORY
    },
  },
  extraReducers: {
    [initProfileRefferal.pending]: (state) => {
      state.isLoadingRefferals = true
    },
    [initProfileRefferal.fulfilled]: (state, { payload }) => {
      state.refferalLinks = payload.refferals
      state.isLoadingRefferals = false
    },
    [initProfileRefferal.rejected]: (state) => {
      state.isLoadingRefferals = false
      state.refferalLinks = []
    },
    [fetchProfileHistory.fulfilled]: (state, { payload }) => {
      state.history = [...state.history, ...payload.history]
      state.pagination = payload.pagination
    },
    [fetchProfileHistory.rejected]: (state) => {
      state.history = []
      state.pagination = {}
    },
    [createRefferalLink.fulfilled]: (state, { payload }) => {
      state.refferalLinks.push(payload.link)
    },
  },
})

export const profileActions = profileSlice.actions

export default profileSlice.reducer
